import isArray from 'is-any-array';

function mode(input) {
  if (!isArray(input)) {
    throw new TypeError('input must be an array');
  }

  if (input.length === 0) {
    throw new TypeError('input must not be empty');
  }

  var maxValue = 0;
  var maxCount = 0;
  var count = 0;
  var counts = {};

  for (var i = 0; i < input.length; ++i) {
    var element = input[i];
    count = counts[element];

    if (count) {
      counts[element]++;
      count++;
    } else {
      counts[element] = count = 1;
    }

    if (count > maxCount) {
      maxCount = count;
      maxValue = input[i];
    }
  }

  return maxValue;
}

export default mode;
